import { WithdrawalTransactionsPage } from 'features/transactions';

export const AdminWithdrawalTransactionsPage: React.FC = () => (
  <WithdrawalTransactionsPage />
);
